import { makeStyles } from "@mui/styles";
import { appColors } from "src/consts/app-config";
import theme from "src/theme";

export const useStyles = makeStyles({
    wrapperPlayers: {
        display: "grid",
        gridTemplateColumns: "1fr auto 1fr",
        alignItems: "center",
        paddingLeft: 16,
        width: "100%",
        "&.secondItem": {},
        [theme.breakpoints.down("lg")]: {
            display: "grid",
            gridTemplateRows: "1fr 1fr",
            alignItems: "centet",
            justifyContent: "center",
            gridTemplateColumns: "1fr",
            overflow: "hidden",
            height: "100%",
            paddingLeft: 5,
            "&.seeOtherAwaitingGame": {
                gridTemplateRows: "1fr",
                height: "50%",
            },
        },
    },
    wrapperSeachingPlayers: {
        display: "flex",
        paddingLeft: 0,
        width: "100%",
        justifyContent: "center",
        [theme.breakpoints.down("lg")]: {
            display: "grid",
            gridTemplateRows: "1fr 1fr",
            alignItems: "centet",
            justifyContent: "center",
            gridTemplateColumns: "1fr",
            overflow: "hidden",
            height: "100%",
            padding: 0,
            "&.myAwaitingGame": {
                gridTemplateRows: "1fr",
                height: "50%",
            },
        },
    },

    versusWrapper: {
        display: "flex",
        alignItems: "center",
        margin: "0 8px",
    },
    versusLine: {
        width: 4,
        height: 2,
        background: "#00ba6b",
    },
    versusText: {
        fontSize: 16,
        fontWeight: 600,
        color: "#00ba6b",
        margin: "0px 4px",
    },

    searchingText: {
        fontSize: 20,
        fontWeight: 400,
        lineHeight: "24px",
        color: "#00BA6C",
        display: "flex",
        // flexDirection: "column",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        [theme.breakpoints.down(1600)]: {
            fontSize: 18,
            lineHeight: "22px",
        },
        [theme.breakpoints.down("xl")]: {
            fontSize: 17,
            flexDirection: "column",
        },
    },
    searchTimeoutText: {
        marginLeft: 0,
        textAlign: "center",
        "&.info": {
            color: appColors.txt300,
        },
        "&.warning": {
            color: "#FF1C29",
        },
    },

    centred: {
        justifyContent: "center !important",
        gridGap: "5px !important",
        margin: "4px 0px",
    },

    bothPlayers: {
        "&.top": {
            "&.topStarted": {
                alignSelf: "end",
                marginBottom: "2px",
            },
        },
        "&.bottom": {
            "&.bottomStarted": {
                alignSelf: "start",
                marginTop: "2px",
            },
        },
    },

});
